var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodehubSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3446_45317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0195 34.3184H25.9807",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4128 38.7285H20.5879V46.5729H29.4128V38.7285Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6455 46.5732H32.3537",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0818 3.42871C47.7066 3.42871 49.0234 4.74561 49.0234 6.37041V35.7868C49.0234 37.4116 47.7065 38.7284 46.0818 38.7284H3.91816C2.29346 38.7284 0.976562 37.4116 0.976562 35.7868V6.37041C0.976562 4.74561 2.29346 3.42871 3.91816 3.42871H46.0818Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.976562 30.8833H49.0234",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5333 24.5311C17.6013 24.5311 20.899 21.2334 20.899 17.1653C20.899 13.0973 17.6013 9.79956 13.5333 9.79956C9.46525 9.79956 6.16748 13.0973 6.16748 17.1653C6.16748 21.2334 9.46525 24.5311 13.5333 24.5311Z",
    fill: "#0A68AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 11.0003C9.91764 11.0003 6.99998 13.9164 6.99998 17.5001C6.99998 21.085 9.91764 24 13.5 24C17.0824 24 20 21.0851 20 17.5001C20 13.9164 17.0824 11.0003 13.5 11.0003ZM13.5 26C18.1823 26 22 22.1874 22 17.5C22 12.8138 18.1824 9 13.5 9C8.81184 9 5 12.8138 5 17.5C5.00012 22.1875 8.81184 26 13.5 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3446_45317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6535 15.4018C15.562 15.2999 15.4308 15.2414 15.2935 15.2414C15.1737 15.2414 15.0586 15.2857 14.9696 15.3658C14.7712 15.5444 14.7551 15.8514 14.9337 16.05L16.2388 17.5L14.9337 18.9502C14.7551 19.1486 14.7712 19.4556 14.9696 19.6342C15.0657 19.7207 15.1906 19.7657 15.319 19.7579C15.4484 19.751 15.5671 19.6945 15.6535 19.5985L17.2504 17.824C17.4165 17.6393 17.4165 17.3607 17.2504 17.1758L15.6535 15.4018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3465 19.5985C11.525 19.7967 11.8316 19.813 12.0304 19.6342C12.2288 19.4556 12.2449 19.1486 12.0664 18.95L10.7612 17.5L12.0664 16.0498C12.2449 15.8514 12.2288 15.5444 12.0304 15.3656C11.9414 15.2857 11.8263 15.2414 11.7065 15.2414C11.5692 15.2414 11.438 15.2999 11.3465 15.4016L9.74962 17.176C9.58348 17.3607 9.58348 17.6393 9.74962 17.824L11.3465 19.5985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6514 20.956L12.6518 20.9562C12.9114 21.0191 13.1738 20.8595 13.2372 20.601L14.7032 14.6299C14.767 14.3707 14.6078 14.1079 14.3483 14.0441C14.3105 14.0348 14.2716 14.0301 14.2327 14.0301C14.0092 14.0301 13.8159 14.1817 13.7627 14.399L12.2966 20.3702C12.2329 20.6294 12.392 20.8921 12.6514 20.956Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 11,
    width: 14,
    height: 14,
    fill: "#0A68AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8825 11.8825V24.1175H44.1177V11.8825H31.8825ZM31.8436 26H44.1564C45.1696 26 46 25.1728 46 24.1552V11.8442C46 10.8282 45.1696 10 44.1564 10H31.8436C30.8305 10 30 10.8282 30 11.8442V24.1552C30.0001 25.1728 30.8305 26 31.8436 26Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3446_45317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3446_45317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "matrix(-1 0 0 -1 17.5 21.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodehubSelected);
export default __webpack_public_path__ + "static/media/codehubSelected.53f3170a872199b74173f26f2476c0a7.svg";
export { ForwardRef as ReactComponent };